    // src/api/aiRewrite.js
    import axios from 'axios';

    const REWRITE_API_URL = '/api/rewrite-text';

    /**
     * Rewrite text using AI with a specified mode
     * @param {string} text - The text to rewrite
     * @param {string} mode - The rewriting mode (strategic, plain, conversational, etc.)
     * @returns {Promise<string>} - The rewritten text
     */
    // Modified version of rewriteTextWithAI
export const rewriteTextWithAI = async (text, mode) => {
    try {
      console.log(`Calling Rewrite API with mode: ${mode}, text length: ${text.length}`);
      
      const response = await axios.post(
        REWRITE_API_URL,
        { 
          text,
          mode
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Rewrite API full response:", response.data);
      
      // Check for BOTH snake_case and camelCase property names
      if (response.data.rewritten_text) {
        console.log("Found rewritten_text property");
        return response.data.rewritten_text;
      } else if (response.data.rewrittenText) {
        console.log("Found rewrittenText property");
        return response.data.rewrittenText;
      } else {
        console.warn("No rewritten text found in response:", response.data);
        return text; // Fallback to original text
      }
    } catch (error) {
      console.error("Error rewriting text:", error.message);
      throw error;
    }
  };